import { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

export default function AdminAuditLogs() {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({ q: "", module: "", action: "" });
  const [error, setError] = useState("");

  async function load() {
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => value && params.set(key, value));
      const data = await api(`/api/admin/audit-logs?${params.toString()}`);
      setRows(data.rows || []);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => { load(); }, []);

  return (
    <AdminLayout title="Activity Logs" subtitle="Review admin actions, failed logins and important CMS changes.">
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      <div className="mb-6 grid gap-3 rounded-3xl bg-white p-4 shadow-sm ring-1 ring-slate-200 md:grid-cols-4">
        <input value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} placeholder="Search description, IP, admin" className="rounded-xl border border-slate-200 px-4 py-3" />
        <input value={filters.module} onChange={(e) => setFilters({ ...filters, module: e.target.value })} placeholder="Module e.g. news" className="rounded-xl border border-slate-200 px-4 py-3" />
        <input value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })} placeholder="Action e.g. update" className="rounded-xl border border-slate-200 px-4 py-3" />
        <button onClick={load} className="rounded-xl bg-emerald-700 px-4 py-3 font-bold text-white">Filter Logs</button>
      </div>

      <div className="overflow-x-auto rounded-3xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-100 text-xs uppercase tracking-wider text-slate-600">
            <tr>
              <th className="p-4">Date</th>
              <th className="p-4">Admin</th>
              <th className="p-4">Action</th>
              <th className="p-4">Module</th>
              <th className="p-4">Description</th>
              <th className="p-4">IP</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((log) => (
              <tr key={log.id} className="border-t border-slate-100">
                <td className="p-4 whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</td>
                <td className="p-4">{log.admin_name || log.admin_email || "System"}</td>
                <td className="p-4"><span className="rounded-full bg-slate-900 px-3 py-1 text-xs font-bold text-white">{log.action}</span></td>
                <td className="p-4">{log.module}</td>
                <td className="p-4 min-w-[260px]">{log.description}</td>
                <td className="p-4">{log.ip_address}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-slate-500">No logs found.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
